import commonApi from './CommonApi.js';

export default {
	requestTranslation: async (viewModel) => {
		return await commonApi().post('/v1/unofficialTranslations/requestTranslation', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}